<template>
    <div class="layout">
        <Layout class="layouts">
            <Sider hide-trigger :style="{height:($store.state.tableHight - 65) + 'px'}" class="rx-sider">
                <Side></Side>
            </Sider>
            <Layout>
                <headers></headers>
                <Content class="em-body" :style="{height:($store.state.tableHight - 65) + 'px'}">
                    <Row>
                        <Col span="24">
                            <div class="em-list-header">
                                <div class="em-list-header-search">
                                    <ButtonGroup >
                                        <Button type="primary"  size="small" class="text-font-sm" @click="CreateData(0)"><Icon type="md-add" /> 添加路由</Button>
                                        <Button type="warning"  size="small" class="text-font-sm" @click="GetList"><Icon type="md-refresh" /> 刷新</Button>
                                    </ButtonGroup>
                                    &nbsp;&nbsp;
                                    <div class="text-999"><small class="text-danger">&nbsp;&nbsp;( 请严格按照路由实际名称填写, 非技术人员请勿随意操作 )</small></div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col span="24">
                            <Table row-key="id" ref="selection" stripe :loading="$store.state.loading" :columns="columns" :data="dataList" no-data-text="暂无数据记录">
                                <template #id="{ row }">
                                    {{row.title}}
                                </template>
                                <template #action="{ row, index }">
                                    <a class="text-success text-font-sm" v-if="row.parent_id === 0" @click="CreateData(row.id)"><Icon type="md-add" />添加</a>
                                    <a class="text-ccc text-font-sm" v-else><Icon type="md-add" />添加</a>
                                    <Divider type="vertical"/>
                                    <a class="text-primary text-font-sm" @click="EditData(row.id)"><Icon type="md-create" />编辑</a>
                                    <Divider type="vertical"/>
                                    <a class="text-999 text-font-sm" @click="DelData(row.id , index)"><Icon type="md-trash" />删除</a>
                                </template>
                            </Table>
                        </Col>
                    </Row>

                    <!-- 创建/编辑路由  -->
                    <add-modal v-if="is_create" ref="AddRef" @trueHandler="SaveData"></add-modal>

                </Content>
            </Layout>
        </Layout>
    </div>
</template>

<script>
import '@/assets/style.css'
import { getAuthList,deleteAuth } from '@/apis/auth'
import Headers from "@/components/public/Headers";
import Side from "@/components/public/Side";
import AddModal from "./Create";
export default {
    name: "AuthIndex",
    components: {
        Headers, Side, AddModal
    },
    data () {
        return {
            dataList : [],
            columns: [
                {
                    title: 'ID',
                    key: 'id',
                    slot : 'id',
                    className : 'role-flex',
                    tree: true
                },
                {
                    title: '排序',
                    key: 'sort',
                    width : 100
                },
                {
                    title: '导航名称',
                    key: 'name'
                },
                {
                    title: '访问地址',
                    key: 'url'
                },
                {
                    title: '文件路径',
                    key: 'file'
                },
                {
                    title: '图标名称',
                    key: 'icon'
                },
                {
                    title: '操作',
                    key: 'action',
                    slot : 'action',
                    align: 'center',
                    width : 200
                }
            ],
            is_create : false,

        }
    },
    created(){
        this.GetList();
    },
    mounted(){
        let that = this;
        that.HeightInit();
    },
    computed: {

    },
    methods: {

        /**
         功能：获取树状路由
         time: 2025-09-01 18:09:28
         **/
        GetList(){
            let that = this;
            that.$store.commit('SET_LOADING' , true);
            getAuthList().then(e=>{
                that.dataList = e.data;
            })
        },

        /**
         功能：创建路由
         time: 2025-26-02 09:26:21
         **/
        CreateData(parentId){
            let that = this;
            that.is_create = true;
            setTimeout(function(){
                that.$refs.AddRef.add(parentId);
            })
        },
        /**
         功能：编辑路由
         time: 2025-26-02 09:26:29
         **/
        EditData(Id){
            let that = this;
            that.is_create = true;
            setTimeout(function(){
                that.$refs.AddRef.edit(Id);
            })
        },
        /**
         功能：路由操作返回
         time: 2025-26-02 09:26:53
         **/
        SaveData(){
            let that = this;
            that.GetList();
        },
        /**
         功能：删除路由
         time: 2025-01-02 12:01:16
         **/
        DelData(Id){
            let that = this;
            if(!Id){
                that.$Message.error({ background: true,duration:3, content:'路由不存在'});
                return;
            }
            that.$Modal.confirm({
                title: '删除路由',
                content: '此操作将删除路由不可恢复, 是否继续?',
                onOk: () => {
                    deleteAuth(Id).then(e=>{
                        that.$Message.success({ background: true,duration:3, content:e.msg});
                        that.GetList();
                    })
                },
                onCancel: () => {}
            });
        },
        HeightInit(){
            this.$store.commit('SET_TABLE_HEIGHT' , window.innerHeight);
            // 动态计算 table 的高度重新赋值
            const that = this;
            window.onresize = function () {
                that.$store.commit('SET_TABLE_HEIGHT' , window.innerHeight);
            }
        }
    }
}
</script>

<style scoped lang="less" rel="stylesheet/less">

</style>
